import React, { useState, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import ApiFetcher from '../../../atoms/api-fetcher/ApiFetcher';
import styles from './styles.scss';
import ThankYouActionBar from '../thank-you-action-bar';
import ThankYouCreateModal from '../thank-you-create-modal';
import { ManageThankYouContext } from './ThankYouManageContext';

const ThankYouManageView = function ThankYouManageView(props) {
    const {
        requesturl, baseurl, charityslug, legacyurl,
    } = props;

    const [pages, setPages] = useState([]);
    const [rows, setRows] = useState(<tr><td>Loading</td></tr>);

    useEffect(() => {
        // Legacy compatibility
        // we need to update iframe height on load and on rows update
        const height = document.getElementsByTagName('html')[0].scrollHeight;
        window.parent.postMessage(['setHeight', height], '*');
    }, [rows]);

    const generateRow = (p) => (
        <tr key={p.Key}>
            <td>{p.Title}</td>
            <td>
                <ThankYouActionBar
                    page={p}
                    baseurl={baseurl}
                    charityslug={charityslug}
                    legacyurl={legacyurl}
                />
            </td>
        </tr>
    );

    const updateList = (p) => {
        setPages(p);
        setRows(p.map((page) => generateRow(page)));
    };

    const handleFetcherResponse = (data, status) => {
        if (status === 200) {
            updateList(data.value);
        }
    };

    const contextValue = useMemo(() => ({ list: pages, updateList }));

    return (
        <ManageThankYouContext.Provider value={contextValue}>
            <div className={styles['thank-you-manage-view']}>
                <ApiFetcher query={requesturl} callback={handleFetcherResponse} />
                <ThankYouCreateModal />
                <table className="table is-striped" style={{ width: '100%' }}>
                    <thead>
                        <tr>
                            <th style={{ width: '50%' }}>Name</th>
                            <th style={{ width: '50%' }}>Manage</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows}
                    </tbody>
                </table>
            </div>
        </ManageThankYouContext.Provider>
    );
};

ThankYouManageView.propTypes = {
    legacyurl: PropTypes.string,
    baseurl: PropTypes.string,
    requesturl: PropTypes.string.isRequired,
    charityslug: PropTypes.string.isRequired,
};

ThankYouManageView.defaultProps = {
    legacyurl: window.location.href,
    baseurl: window.location.href,
};

export default ThankYouManageView;
